import React , { useCallback } from 'react';
import PopUpDialogTemplate from './PopUpDialogTemplate';



const TournamentRebuyDialog = ({data, onConfirm, onClose, t}) => {

  const BTN_NAMES = {
    confirm: 'Re-buy Now',
    cancel: t('cancel'),
  };

  data = {
    currency: 'USD',
    totalChange: '$ 1',
    availableBalance: '$ 499' 
  } 

  return (
    <>
    <div className="tournaments__popup tournament__dialog__rebuy">
      <div className="tournaments__popup__overlay tournament__rebuy__overlay" onClick={onClose} />
      <PopUpDialogTemplate
        title={'Tournament Re-buy'}
        iconName={"rebuy"}
        onConfirm={onConfirm}
        onClose={onClose}
        btnNames={BTN_NAMES}
      >

        <div className="tournament__dialog-currency">
          <span>{`Total Charge:`} <p>{data.totalChange}</p></span>
          <span>{`Available Balance:`} <p>{data.availableBalance}</p></span>
        </div>

      </PopUpDialogTemplate>
    </div>
    </>
  )
}

export default TournamentRebuyDialog;